import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=127393ae&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "../../components/common/css/Auth.css?vue&type=style&index=0&id=127393ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127393ae",
  null
  
)

export default component.exports